import React, { Fragment } from "react";
import packageJson from "../../../package.json";
import { useTranslation } from "react-i18next";

const AppFooter = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <div className="app-footer">
        <div className="app-footer__inner">
          <div className="app-footer-left"></div>
          <div className="app-footer-right">
            <h6>
              {t("dashboardheading")} {packageJson.version}
            </h6>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AppFooter;
